"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  self.addEventListener('message', function (evennement) {
    /* eslint-disable-line no-restricted-globals */
    if (!evennement) {
      return;
    }

    var data = evennement.data;
    var donneesSortante = obtenirDonnees(data);
    postMessage({
      type: data.type,
      donnees: donneesSortante,
      nomColonne: data.nomColonne
    });
  });

  function echapperTermeExpression(terme) {
    if (!terme) {
      return terme;
    }

    var caracteres = ['.', '\\', '$', '^', '?', '<', '>', '[', ']'];
    var caractere;

    while (caractere = caracteres.shift()) {
      var valeurRemplace = "\\".concat(caractere);
      terme = terme.replace(new RegExp(valeurRemplace, 'g'), valeurRemplace);
    }

    return terme;
  }

  function obtenirDonnees(data) {
    var type = data.type,
        donnees = data.donnees,
        tri = data.tri,
        filtre = data.filtre,
        termeRecherche = data.termeRecherche,
        termeRechercheColonne = data.termeRechercheColonne,
        nomColonne = data.nomColonne,
        nomsColonnes = data.nomsColonnes,
        fonctionTri = data.fonctionTri,
        fonctionsValeurs = data.fonctionsValeurs,
        fonctionsFiltres = data.fonctionsFiltres;
    termeRecherche = echapperTermeExpression(termeRecherche);
    termeRechercheColonne = echapperTermeExpression(termeRechercheColonne);
    var fonctionsValeursRecuperes = recupererObjFonction(fonctionsValeurs);
    var fonctionsFiltresRecuperes = recupererObjFonction(fonctionsFiltres);

    function recupererObjFonction(objChaineFonction) {
      if (!objChaineFonction) {
        return {};
      }

      var obj = {};
      Object.keys(objChaineFonction).forEach(function (propriete) {
        var fonction = recupererFonction(objChaineFonction[propriete]);

        if (fonction) {
          obj[propriete] = fonction;
        }
      });
      return obj;
    }

    function recupererFonction(chaineFonction) {
      if (!chaineFonction) {
        return null;
      }

      var fonction;

      try {
        eval("fonction = ".concat(chaineFonction, ";"));
      } catch (e) {}

      return fonction;
    }

    function obtenirValeurFormattee(donnee, nomColonne) {
      var fonctionValeur = fonctionsValeursRecuperes[nomColonne];
      var valeur = donnee[nomColonne];

      if (typeof fonctionValeur === 'function') {
        try {
          valeur = fonctionValeur(valeur, donnee);
        } catch (e) {}
      }

      return valeur;
    }

    function valeurCorrespond(valeur, expressionMatch) {
      valeur = valeur && valeur.toString();
      return !!(valeur ? valeur.match(expressionMatch) : false);
    }

    function valeursFiltres(donnees) {
      var expressionRecherche = termeRechercheColonne ? new RegExp(termeRechercheColonne, 'i') : null;
      var liste = donnees.map(function (donnee) {
        return obtenirValeurFormattee(donnee, nomColonne);
      }).reduce(function (liste, valeur) {
        if (liste.indexOf(valeur) === -1 && (!expressionRecherche || valeurCorrespond(valeur, expressionRecherche))) {
          liste.push(valeur);
        }

        return liste;
      }, []);
      liste.sort();
      return liste;
    }

    function trier(donnees) {
      if (!donnees || !donnees.sort || !tri || !tri.nom) {
        return donnees;
      }

      var nom = tri.nom,
          descendant = tri.descendant;
      var avant = descendant ? 1 : -1;
      var apres = descendant ? -1 : 1;
      var fonctionTriRecupere = recupererFonction(fonctionTri);
      fonctionTriRecupere = typeof fonctionTriRecupere === 'function' ? fonctionTriRecupere : null;
      donnees.sort(function (donneeA, donneeB) {
        if (fonctionTriRecupere) {
          return fonctionTriRecupere(donneeA, donneeB, descendant);
        }

        var valeurA = obtenirValeurFormattee(donneeA, nom);
        var valeurB = obtenirValeurFormattee(donneeB, nom);

        if (valeurA === undefined) {
          return valeurB === undefined ? 0 : avant;
        } else if (valeurB === undefined) {
          return apres;
        }

        return valeurA > valeurB ? apres : valeurA < valeurB ? avant : 0;
      });
      return donnees;
    }

    function rechercher(donnees) {
      if (!donnees || !donnees.filter) {
        return;
      }

      if (!termeRecherche) {
        return donnees;
      }

      var expressionMatch = new RegExp(termeRecherche, 'i');
      var donneesSortantes = donnees.filter(function (donnee) {
        return nomsColonnes.some(function (nomColonne) {
          var valeur = obtenirValeurFormattee(donnee, nomColonne);
          return valeurCorrespond(valeur, expressionMatch);
        });
      });
      return donneesSortantes;
    }

    function filtrer(donnees) {
      if (!donnees || !donnees.filter || !filtre) {
        return donnees;
      }

      var colonnesFiltre = Object.keys(filtre).filter(function (colonne) {
        return filtre[colonne] && filtre[colonne].length;
      });

      if (!colonnesFiltre.length) {
        return donnees;
      }

      var donneesSortantes = donnees.filter(function (donnee) {
        return colonnesFiltre.every(function (nomColonne) {
          var valeurs = filtre[nomColonne];
          var valeur = obtenirValeurFormattee(donnee, nomColonne);
          var fonctionFiltre = fonctionsFiltresRecuperes[nomColonne];

          if (typeof fonctionFiltre === 'function') {
            try {
              return fonctionFiltre(donnee, valeurs);
            } catch (e) {
              return false;
            }
          }

          return valeurs.indexOf(valeur) !== -1;
        });
      });
      return donneesSortantes;
    }

    var donneesSortante;

    if (['filtrer-ajout', 'filtrer-retrait', 'recherche'].indexOf(type) !== -1) {
      donneesSortante = rechercher(donnees);
      donneesSortante = filtrer(donneesSortante);
      donneesSortante = trier(donneesSortante);
    } else if (type === 'valeurs-filtre') {
      donneesSortante = rechercher(donnees);
      donneesSortante = filtrer(donneesSortante);
      donneesSortante = valeursFiltres(donneesSortante);
    } else if (type === 'tri') {
      donneesSortante = trier(donnees, tri);
    } else {
      donneesSortante = donnees;
    }

    return donneesSortante;
  }
};

exports.default = _default;